import React from 'react';
import { SyslogServer } from '../types';
import { Level } from '../SyslogConfig';

interface Props {
    title: string;
    servers: SyslogServer[];
    searchTerm: string;
    handleSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    handleMoveServer: (servers: SyslogServer[], toSelected: boolean) => void;
    handleLevelChange: (id: number, level: string) => void;
    handleSelectServer: (server: SyslogServer) => void;
    pagination: JSX.Element;
    isSelected: boolean;
}

const SyslogServerList: React.FC<Props> = ({
    title,
    servers,
    searchTerm,
    handleSearchChange,
    handleMoveServer,
    handleLevelChange,
    handleSelectServer,
    pagination,
    isSelected
}) => (
    <div className="syslog-column">
        <div className="search-container">
            <div><h3>{title}</h3></div>
            <div>
                <input
                    type="text"
                    value={searchTerm}
                    onChange={handleSearchChange}
                    placeholder="Search"
                    className="search-input"
                />
            </div>
        </div>
        <table className="w-full f-parrafo caption-bottom custom-table" id="table">
            <thead >
                <tr className='text-azul'>
                    {!isSelected && <th className="table-cell">Select</th>}
                    {isSelected && <th className="table-cell">Select</th>}
                    <th className="table-cell">IP</th>
                    <th className="table-cell">Name</th>
                    {isSelected && <th className="table-cell">Level</th>}
                </tr>
            </thead>
            <tbody>
                {servers.length === 0 ? (
                    <tr>
                        <td colSpan={isSelected ? 4 : 3} className="table-cell text-center">
                            No data available
                        </td>
                    </tr>
                ) : (
                    servers.map(server => (
                        <tr key={server.id} className="table-row">
                            {!isSelected && (
                                <td className="table-cell">
                                    <input
                                        type="checkbox"
                                        onChange={() => handleSelectServer(server)}
                                    />
                                </td>
                            )}
                            {isSelected && (
                                <>
                                    <td className="table-cell">
                                        <input
                                            type="checkbox"
                                            onChange={() => handleSelectServer(server)}
                                        />
                                    </td>
                                </>
                            )}
                            <td className="table-cell">{server.ip}</td>
                            <td className="table-cell">{server.description}</td>
                            {isSelected && (
                                <>
                                    <td className="table-cell">
                                    <select value={server.level} onChange={e => handleLevelChange(server.id, e.target.value)} className="syslog-select">
                                            {Object.entries(Level).map(([key, value]) => (
                                                <option key={key} value={key}>{value}</option>
                                            ))}
                                        </select>
                                    </td>
                                </>
                            )}
                        </tr>
                    ))
                )}
            </tbody>
        </table>
        {pagination}
    </div>
);

export default SyslogServerList;